import React from "react";
import PropTypes from "prop-types";

export const EditIcon = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0838 3.28132C13.3461 3.15134 13.6541 3.15134 13.9164 3.28133C14.0334 3.33932 14.1613 3.45673 14.6023 3.89777C15.0433 4.3388 15.1607 4.46672 15.2187 4.58372C15.3487 4.84602 15.3487 5.15397 15.2187 5.41627C15.1607 5.53327 15.0433 5.66119 14.6023 6.10221L14.0271 6.67745C12.8588 6.57152 11.9285 5.64127 11.8226 4.47301L12.3979 3.89774C12.8389 3.45671 12.9668 3.3393 13.0838 3.28132ZM10.8819 5.41368L5.17542 11.1201C4.77975 11.5158 4.63109 11.6673 4.51433 11.8347C4.40488 11.9916 4.31429 12.1609 4.24443 12.339C4.1699 12.529 4.1263 12.7367 4.01656 13.2854L3.71706 14.783L5.21459 14.4834C5.76328 14.3737 5.97102 14.3301 6.16103 14.2556C6.33914 14.1857 6.50841 14.0951 6.66533 13.9857C6.83275 13.8689 6.98425 13.7203 7.37992 13.3246L13.0864 7.61813C12.0549 7.26185 11.2382 6.44512 10.8819 5.41368ZM14.4159 2.27333C13.8389 1.98735 13.1614 1.98734 12.5843 2.27331C12.2789 2.42465 12.0118 2.69219 11.6667 3.0378L11.6024 3.10224L4.37993 10.3246L4.34376 10.3608C3.99623 10.7082 3.77215 10.9322 3.59158 11.1911C3.43162 11.4205 3.29922 11.6679 3.19711 11.9282C3.08185 12.222 3.01975 12.5328 2.92344 13.0147L2.91341 13.0648L2.44843 15.3897C2.41155 15.5741 2.46927 15.7648 2.60226 15.8978C2.73525 16.0307 2.9259 16.0885 3.11032 16.0516L5.43522 15.5866L5.48537 15.5766L5.4854 15.5766C5.96726 15.4803 6.27798 15.4182 6.57183 15.3029C6.83214 15.2008 7.07953 15.0684 7.30888 14.9084C7.56779 14.7279 7.79182 14.5038 8.13925 14.1563L8.17541 14.1201L15.3978 6.89771L15.4622 6.83334L15.4623 6.83333C15.8078 6.48829 16.0754 6.22119 16.2267 5.91581C16.5127 5.33876 16.5127 4.66125 16.2267 4.0842C16.0754 3.77881 15.8079 3.5117 15.4623 3.16665L15.3978 3.10229L15.3335 3.03784C14.9884 2.69222 14.7213 2.42467 14.4159 2.27333Z"
        fill="#9F9F9F"
      />
    </svg>
  );
};

export const VisaIcon = ({ color1 = "White", color2 = "White" }) => {
  return (
    <svg
      width="42"
      height="14"
      viewBox="0 0 42 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.0315 1.03482H36.4121C35.6202 1.03482 35.011 1.26874 34.6455 2.02897L29.6504 12.9646H33.1835C33.1835 12.9646 33.7927 11.5027 33.9145 11.1518C34.28 11.1518 37.7522 11.1518 38.2396 11.1518C38.3614 11.5611 38.666 12.9062 38.666 12.9062H41.8336L39.0315 1.03482ZM34.8892 8.69564C35.1938 7.99388 36.2293 5.36231 36.2293 5.36231C36.2293 5.42078 36.5339 4.66055 36.6558 4.25119L36.8994 5.30383C36.8994 5.30383 37.5695 8.16932 37.6913 8.75412H34.8892V8.69564Z"
        fill={color2}
      />
      <path
        d="M29.8907 9.04657C29.8907 11.5027 27.5759 13.1401 23.9819 13.1401C22.459 13.1401 20.997 12.8477 20.2051 12.4969L20.6924 9.8068L21.1188 9.98224C22.2153 10.4501 22.9463 10.6255 24.2865 10.6255C25.2611 10.6255 26.2967 10.2746 26.2967 9.45593C26.2967 8.92961 25.8703 8.57873 24.5301 7.99394C23.2509 7.40914 21.5452 6.47347 21.5452 4.77756C21.5452 2.43838 23.921 0.859436 27.2714 0.859436C28.5506 0.859436 29.6471 1.09335 30.3172 1.38575L29.8298 3.95885L29.5862 3.72493C28.977 3.49101 28.1851 3.2571 27.0277 3.2571C25.7484 3.31558 25.1393 3.84189 25.1393 4.30973C25.1393 4.83604 25.8703 5.2454 27.0277 5.77172C28.977 6.64891 29.8907 7.64306 29.8907 9.04657Z"
        fill={color2}
      />
      <path
        d="M0.166016 1.15183L0.226932 0.917908H5.46572C6.19672 0.917908 6.74496 1.15183 6.92771 1.91206L8.08512 7.17522C6.92771 4.3682 4.2474 2.0875 0.166016 1.15183Z"
        fill={color1}
      />
      <path
        d="M15.4552 1.0351L10.1555 12.9064H6.56143L3.51562 2.96493C5.70861 4.30996 7.53609 6.41522 8.20617 7.87721L8.57167 9.10528L11.8611 0.976624H15.4552V1.0351Z"
        fill={color2}
      />
      <path
        d="M16.8567 0.976624H20.2071L18.075 12.9064H14.7246L16.8567 0.976624Z"
        fill={color2}
      />
    </svg>
  );
};

export const discoverIcon = () => {
  return(
    <svg version="1.1" width='42px' height='42px' id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 291.764 291.764" style={{ enableBackground: 'new 0 0 291.764 291.764' }}  >
<g>
	<path fill='#E4E7E7' d="M18.235,41.029h255.294c10.066,0,18.235,8.16,18.235,18.235V232.5
		c0,10.066-8.169,18.235-18.235,18.235H18.235C8.169,250.735,0,242.566,0,232.5V59.265C0,49.19,8.169,41.029,18.235,41.029z"/>
	<path fill='#324D5B' d="M58.681,77.491H36.452v72.978h22.11c11.734,0,20.223-2.617,27.663-8.425
		c8.826-6.893,14.069-17.296,14.069-28.037C100.294,92.462,83.189,77.491,58.681,77.491z M75.148,127.756
		c-3.948,3.064-9.026,4.376-17.105,4.376h-3.346V95.808h3.346c8.078,0,12.965,1.231,17.105,4.431
		c4.322,3.301,6.902,8.406,6.902,13.676C82.05,119.186,79.469,124.483,75.148,127.756z M109.43,150.459h18.108V77.363H109.43
		V150.459z M168.649,105.619c-9.254-3.027-11.971-5.042-11.971-8.799c0-4.395,4.851-7.768,11.488-7.768
		c4.623,0,8.406,1.678,12.446,5.662l8.042-9.327c-6.638-5.142-14.561-7.768-23.214-7.768c-13.95,0-24.618,8.598-24.618,20.022
		c0,9.665,4.969,14.588,19.421,19.202c6.036,1.887,9.109,3.136,10.649,3.994c3.082,1.787,4.632,4.285,4.632,7.221
		c0,5.68-5.106,9.865-11.971,9.865c-7.34,0-13.257-3.237-16.813-9.327l-9.929,8.516c7.075,9.218,15.609,13.33,27.335,13.33
		c15.983,0,27.225-9.455,27.225-22.986C191.37,116.341,186.173,111.308,168.649,105.619z M218.878,113.87
		c0-11.361,9.163-20.323,20.825-20.323c5.908,0,10.412,1.951,15.573,6.647l-0.009-18.436c-6.081-3.009-11.105-4.258-17.077-4.258
		c-21.025,0-37.875,16.193-37.875,36.452c0,20.496,16.439,36.361,37.565,36.361c5.972,0,11.096-1.14,17.387-4.057l0.009-18.445
		c-4.978,4.623-9.364,6.483-15.008,6.483C227.759,134.294,218.878,125.851,218.878,113.87z"/>
	<path fill='#F4B459'  d="M273.529,250.735c10.066,0,18.235-8.169,18.235-18.235v-72.941l-164.118,91.176L273.529,250.735
		L273.529,250.735z"/>
</g>
</svg>
  )
}

export const amexIcon = () => {
  return(
    <svg version="1.1" width='42px' height='42px' id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
       viewBox="0 0 291.764 291.764" style={{ enableBackground: 'new 0 0 291.764 291.764' }}  >
    <g>
      <path fill='#26A6D1' d="M18.235,41.025h255.294c10.066,0,18.235,8.169,18.235,18.244v173.235
        c0,10.066-8.169,18.235-18.235,18.235H18.235C8.16,250.74,0,242.57,0,232.505V59.269C0,49.194,8.169,41.025,18.235,41.025z"/>
      <path fill='#FFFFFF' d="M47.047,113.966l-28.812,63.76h34.492l4.276-10.166h9.774l4.276,10.166h37.966v-7.759l3.383,7.759
        h19.639l3.383-7.923v7.923h78.959l9.601-9.902l8.99,9.902l40.555,0.082l-28.903-31.784l28.903-32.058h-39.926l-9.346,9.719
        l-8.707-9.719h-85.897l-7.376,16.457l-7.549-16.457h-34.42v7.495l-3.829-7.495C76.479,113.966,47.047,113.966,47.047,113.966z
         M53.721,123.02h16.813l19.111,43.236V123.02h18.418l14.761,31l13.604-31h18.326v45.752h-11.151l-0.091-35.851l-16.257,35.851
        h-9.975l-16.348-35.851v35.851h-22.94l-4.349-10.257H50.147l-4.34,10.248H33.516C33.516,168.763,53.721,123.02,53.721,123.02z
         M164.956,123.02h45.342L224.166,138l14.315-14.98h13.868l-21.071,22.995l21.071,22.73h-14.497l-13.868-15.154l-14.388,15.154
        h-44.64L164.956,123.02L164.956,123.02z M61.9,130.761l-7.741,18.272h15.473L61.9,130.761z M176.153,132.493v8.352h24.736v9.309
        h-24.736v9.118h27.745l12.892-13.43l-12.345-13.357h-28.292L176.153,132.493z"/>
    </g>
    </svg>
  )
}

export const jcbIcon = () => {
  return(
    <svg width='42px' height='25px' viewBox="0 0 256 198" version="1.1" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
    <defs>
        <linearGradient x1="-57.5270968%" y1="50.1241953%" x2="232.39121%" y2="50.1241953%" id="linearGradient-1">
            <stop stopColor="#007940" offset="0%"></stop>
            <stop stopColor="#00873F" offset="22.85%"></stop>
            <stop stopColor="#40A737" offset="74.33%"></stop>
            <stop stopColor="#5CB531" offset="100%"></stop>
        </linearGradient>
        <linearGradient x1="0.182516704%" y1="49.95997%" x2="100.273441%" y2="49.95997%" id="linearGradient-2">
            <stop stopColor="#007940" offset="0%"></stop>
            <stop stopColor="#00873F" offset="22.85%"></stop>
            <stop stopColor="#40A737" offset="74.33%"></stop>
            <stop stopColor="#5CB531" offset="100%"></stop>
        </linearGradient>
        <linearGradient x1="-62.8015845%" y1="49.8578253%" x2="253.671294%" y2="49.8578253%" id="linearGradient-3">
            <stop stopColor="#007940" offset="0%"></stop>
            <stop stopColor="#00873F" offset="22.85%"></stop>
            <stop stopColor="#40A737" offset="74.33%"></stop>
            <stop stopColor="#5CB531" offset="100%"></stop>
        </linearGradient>
        <linearGradient x1="0.175556793%" y1="50.0058048%" x2="101.808162%" y2="50.0058048%" id="linearGradient-4">
            <stop stopColor="#1F286F" offset="0%"></stop>
            <stop stopColor="#004E94" offset="47.51%"></stop>
            <stop stopColor="#0066B1" offset="82.61%"></stop>
            <stop stopColor="#006FBC" offset="100%"></stop>
        </linearGradient>
        <linearGradient x1="-0.575855512%" y1="49.9142191%" x2="98.13299%" y2="49.9142191%" id="linearGradient-5">
            <stop stopColor="#6C2C2F" offset="0%"></stop>
            <stop stopColor="#882730" offset="17.35%"></stop>
            <stop stopColor="#BE1833" offset="57.31%"></stop>
            <stop stopColor="#DC0436" offset="85.85%"></stop>
            <stop stopColor="#E60039" offset="100%"></stop>
        </linearGradient>
    </defs>
	<g>
		<path d="M256.000001,157.418094 C256.000001,179.325184 238.16137,197.163815 216.254279,197.163815 L-3.43623867e-08,197.163815 L-3.43623867e-08,39.7457218 C-3.43623867e-08,17.8386312 17.8386309,3.69395977e-07 39.7457214,3.69395977e-07 L256.000001,3.69395977e-07 L256.000001,157.418094 Z" fill="#FFFFFF"></path>
		<path d="M185.584353,117.046455 L202.01467,117.046455 C202.484108,117.046455 203.579463,116.889977 204.048901,116.889977 C207.178485,116.26406 209.838631,113.447434 209.838631,109.535453 C209.838631,105.779952 207.178485,102.963326 204.048901,102.18093 C203.579463,102.024451 202.640588,102.024451 202.01467,102.024451 L185.584353,102.024451 L185.584353,117.046455 Z" fill="url(#linearGradient-1)"></path>
		<path d="M200.13692,13.3007339 C184.488999,13.3007339 171.657702,25.9755506 171.657702,41.7799516 L171.657702,71.354524 L211.872861,71.354524 C212.811737,71.354524 213.907092,71.354524 214.689488,71.511003 C223.765282,71.980441 230.493888,76.6748175 230.493888,84.8117365 C230.493888,91.2273845 225.955991,96.7041575 217.506113,97.799512 L217.506113,98.11247 C226.738387,98.738387 233.779952,103.902201 233.779952,111.882641 C233.779952,120.488998 225.955991,126.122251 215.628363,126.122251 L171.501223,126.122251 L171.501223,184.019561 L213.281174,184.019561 C228.929097,184.019561 241.760392,171.344744 241.760392,155.540344 L241.760392,13.3007339 L200.13692,13.3007339 L200.13692,13.3007339 Z" fill="url(#linearGradient-2)"></path>
		<path d="M207.804402,86.6894875 C207.804402,82.933986 205.144255,80.4303185 202.01467,79.960881 C201.701713,79.960881 200.919316,79.8044015 200.449879,79.8044015 L185.584353,79.8044015 L185.584353,93.574573 L200.449879,93.574573 C200.919316,93.574573 201.858192,93.574573 202.01467,93.4180935 C205.144255,92.948656 207.804402,90.4449885 207.804402,86.6894875 L207.804402,86.6894875 Z" fill="url(#linearGradient-3)"></path>
		<path d="M42.7188266,13.3007339 C27.0709047,13.3007339 14.2396088,25.9755506 14.2396088,41.7799516 L14.2396088,112.03912 C22.2200489,115.951101 30.5134475,118.454768 38.8068461,118.454768 C48.6650368,118.454768 53.9853305,112.508558 53.9853305,104.371639 L53.9853305,71.1980445 L78.3960885,71.1980445 L78.3960885,104.215159 C78.3960885,117.046455 70.415648,127.530563 43.3447434,127.530563 C26.9144255,127.530563 14.0831296,123.931541 14.0831296,123.931541 L14.0831296,183.863082 L55.863081,183.863082 C71.5110025,183.863082 84.3422985,171.188265 84.3422985,155.383864 L84.3422985,13.3007339 L42.7188266,13.3007339 L42.7188266,13.3007339 Z" fill="url(#linearGradient-4)"></path>
		<path d="M121.427874,13.3007339 C105.779951,13.3007339 92.9486555,25.9755506 92.9486555,41.7799517 L92.9486555,79.0220055 C100.146699,72.919316 112.665037,69.0073355 132.850856,69.946211 C143.647922,70.4156485 155.227384,73.3887535 155.227384,73.3887535 L155.227384,85.4376535 C149.437654,82.4645485 142.552568,79.8044015 133.633252,79.178485 C118.298289,78.0831305 109.066015,85.594133 109.066015,98.738387 C109.066015,112.03912 118.298289,119.550123 133.633252,118.298289 C142.552568,117.672372 149.437654,114.855746 155.227384,112.03912 L155.227384,124.08802 C155.227384,124.08802 143.804402,127.061126 132.850856,127.530563 C112.665037,128.469438 100.146699,124.557458 92.9486555,118.454768 L92.9486555,184.17604 L134.728607,184.17604 C150.376529,184.17604 163.207824,171.501223 163.207824,155.696822 L163.207824,13.3007339 L121.427874,13.3007339 L121.427874,13.3007339 Z" fill="url(#linearGradient-5)"></path>
	</g>
</svg>

  )
}

export const MasterIcon = () => {
  return (
    <svg
      width="50"
      height="32"
      viewBox="0 0 50 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.5115 6.52758L19.4551 6.7132L20.4841 25.4729L30.5405 25.2873L29.5115 6.52758Z"
        fill="#FF5F00"
      />
      <path
        d="M19.9166 15.9829C19.7026 12.1812 21.2811 8.77733 23.8761 6.54648C21.7894 4.99565 19.2142 4.08238 16.4637 4.13194C9.94758 4.24936 4.97526 9.66681 5.34543 16.2455C5.71559 22.8242 11.2869 28.0516 17.8029 27.9342C20.5535 27.8846 23.0208 26.8805 24.9289 25.2577C22.0902 23.1579 20.1305 19.7847 19.9166 15.9829Z"
        fill="#EB001B"
      />
      <path
        d="M44.6466 15.7556C45.0168 22.3343 40.0445 27.7517 33.5284 27.8691C30.7779 27.9187 28.2027 27.0054 26.116 25.4546C28.7437 23.2232 30.2894 19.8199 30.0755 16.0182C29.8616 12.2164 27.9037 8.8763 25.0632 6.7434C26.9713 5.12059 29.4386 4.11645 32.1891 4.06689C38.7052 3.94947 44.2783 9.20998 44.6466 15.7556Z"
        fill="#F79E1B"
      />
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0.1875C6.31066 0.1875 6.5625 0.43934 6.5625 0.75V5.4375H11.25C11.5607 5.4375 11.8125 5.68934 11.8125 6C11.8125 6.31066 11.5607 6.5625 11.25 6.5625H6.5625V11.25C6.5625 11.5607 6.31066 11.8125 6 11.8125C5.68934 11.8125 5.4375 11.5607 5.4375 11.25V6.5625H0.75C0.43934 6.5625 0.1875 6.31066 0.1875 6C0.1875 5.68934 0.43934 5.4375 0.75 5.4375H5.4375V0.75C5.4375 0.43934 5.68934 0.1875 6 0.1875Z"
        fill="#9F9F9F"
      />
    </svg>
  );
};

export const DefaultIcon = ({ color }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.54651 9C2.54651 5.43584 5.43584 2.54651 9 2.54651C12.5642 2.54651 15.4535 5.43584 15.4535 9C15.4535 12.5642 12.5642 15.4535 9 15.4535C5.43584 15.4535 2.54651 12.5642 2.54651 9ZM9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5ZM12.1607 7.27697C12.365 7.07263 12.365 6.74132 12.1607 6.53698C11.9564 6.33263 11.625 6.33263 11.4207 6.53698L8.30233 9.65535L7.27697 8.63C7.07263 8.42566 6.74132 8.42566 6.53698 8.63C6.33263 8.83435 6.33263 9.16565 6.53698 9.37L7.93233 10.7653C8.03046 10.8635 8.16355 10.9186 8.30233 10.9186C8.4411 10.9186 8.57419 10.8635 8.67232 10.7653L12.1607 7.27697Z"
        fill={color}
      />
    </svg>
  );
};

export const OtherIcon = ({ color }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.54651 9C2.54651 5.43584 5.43584 2.54651 9 2.54651C12.5642 2.54651 15.4535 5.43584 15.4535 9C15.4535 12.5642 12.5642 15.4535 9 15.4535C5.43584 15.4535 2.54651 12.5642 2.54651 9ZM9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5Z"
        fill={color}
      />
    </svg>
  );
};

export const TrashIcon = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.04737 1.43766L7.96577 1.43758C7.58131 1.437 7.24388 1.4365 6.94322 1.55475C6.68032 1.65815 6.44758 1.8259 6.26635 2.04261C6.05909 2.29045 5.95286 2.61073 5.83183 2.97563L5.8061 3.05307L5.59457 3.68766H3H1.5C1.18934 3.68766 0.9375 3.9395 0.9375 4.25016C0.9375 4.56082 1.18934 4.81266 1.5 4.81266H2.46962L2.9227 12.5151L2.9241 12.539C2.96968 13.3139 3.00585 13.9288 3.07476 14.424C3.14532 14.9312 3.25543 15.3586 3.47369 15.7466C3.8285 16.3775 4.36702 16.8852 5.01757 17.2024C5.41776 17.3975 5.85094 17.4823 6.36132 17.523C6.85976 17.5627 7.47577 17.5627 8.25201 17.5627H8.27594H9.72406H9.74799C10.5242 17.5627 11.1402 17.5627 11.6387 17.523C12.1491 17.4823 12.5822 17.3975 12.9824 17.2024C13.633 16.8852 14.1715 16.3775 14.5263 15.7466C14.7446 15.3586 14.8547 14.9312 14.9252 14.424C14.9941 13.9288 15.0303 13.314 15.0759 12.5392V12.5391L15.0759 12.5391L15.0773 12.5151L15.5304 4.81266H16.5C16.8107 4.81266 17.0625 4.56082 17.0625 4.25016C17.0625 3.9395 16.8107 3.68766 16.5 3.68766H15H12.4054L12.1939 3.05307L12.1682 2.97563C12.0471 2.61073 11.9409 2.29045 11.7337 2.04261C11.5524 1.8259 11.3197 1.65815 11.0568 1.55475C10.7561 1.4365 10.4187 1.437 10.0342 1.43758L9.95263 1.43766H8.04737ZM11.9869 4.81266C11.9955 4.81286 12.0043 4.81286 12.013 4.81266H14.4034L13.9542 12.449C13.9069 13.2531 13.873 13.8233 13.811 14.269C13.7499 14.7079 13.6669 14.9797 13.5458 15.1951C13.303 15.6267 12.9345 15.9742 12.4894 16.1912C12.2673 16.2994 11.9911 16.3663 11.5493 16.4015C11.1008 16.4372 10.5296 16.4377 9.72406 16.4377H8.27594C7.47043 16.4377 6.8992 16.4372 6.45065 16.4015C6.00893 16.3663 5.7327 16.2994 5.51057 16.1912C5.06545 15.9742 4.69699 15.6267 4.45422 15.1951C4.33307 14.9797 4.25009 14.7079 4.18903 14.269C4.12702 13.8233 4.09306 13.2531 4.04576 12.449L3.59656 4.81266H5.98703C5.99575 4.81286 6.00445 4.81286 6.01313 4.81266H11.9869ZM11.2196 3.68766L11.1266 3.40883C10.9639 2.92071 10.9225 2.8263 10.8706 2.76431C10.8102 2.69207 10.7327 2.63616 10.645 2.60169C10.5698 2.57211 10.4672 2.56266 9.95263 2.56266H8.04737C7.53285 2.56266 7.43018 2.57211 7.35498 2.60169C7.26734 2.63616 7.18976 2.69207 7.12935 2.76431C7.07751 2.8263 7.03608 2.92071 6.87337 3.40883L6.78043 3.68766H11.2196ZM8.0625 8.00016C8.0625 7.6895 7.81066 7.43766 7.5 7.43766C7.18934 7.43766 6.9375 7.6895 6.9375 8.00016V13.2502C6.9375 13.5608 7.18934 13.8127 7.5 13.8127C7.81066 13.8127 8.0625 13.5608 8.0625 13.2502V8.00016ZM10.5 7.43766C10.8107 7.43766 11.0625 7.6895 11.0625 8.00016V11.0002C11.0625 11.3108 10.8107 11.5627 10.5 11.5627C10.1893 11.5627 9.9375 11.3108 9.9375 11.0002V8.00016C9.9375 7.6895 10.1893 7.43766 10.5 7.43766Z"
        fill="#9F9F9F"
      />
    </svg>
  );
};

EditIcon.propTypes = {};
VisaIcon.propTypes = {
  color1: PropTypes.string,
  color2: PropTypes.string,
};
MasterIcon.propTypes = {};
AddIcon.propTypes = {};
DefaultIcon.propTypes = {
  color: PropTypes.string,
};
OtherIcon.propTypes = {
  color: PropTypes.string,
};
TrashIcon.propTypes = {};
discoverIcon.propTypes = {}
jcbIcon.propTypes = {}